<template>
  <div class="kibiki">
    <h3>忌引き届</h3>
    <div class="multi-date-table">
      <div class="item flex">
        <b class="width-115">取得日</b>
        <p>{{ kibiki?.kibiki_start_date }}</p>
      </div>
      <div class="item flex" style="margin-bottom: 0;">
        <b class="width-115">就業場所</b>
        <p>{{ form.syuugyou_basyo_name }}</p>
      </div>
      <div class="item flex" style="margin-bottom: 0;">
        <b class="width-115">就業時間</b>
        <p>{{ getWorkTime(kibiki?.kibiki_start_date) }}</p>
      </div>
      <div class="item flex">
        <b class="width-115">区分（取得時間）</b>
        <p>{{ divStr(kibiki?.kibiki_tani_type) }}（{{ timeFormat(kibiki?.kibiki_times) }}時間）</p>
      </div>
    </div>
    <div class="col-item">
      <b class="title">故人氏名</b>
      <p>{{ kibiki?.kojin_name }}</p>
    </div>
    <div class="col-item">
      <b class="title">よみがな<br>（故人氏名）</b>
      <p>{{ kibiki?.kojin_kana }}</p>
    </div>
    <div class="col-item">
      <b class="title">続柄</b>
      <p>{{ kibiki?.tsuzukigara }}</p>
    </div>
    <div class="col-item">
      <b class="title">死去した日付</b>
      <p>{{ kibiki?.sikyo_date }}</p>
    </div>

    <!-- MEDICA_AS-1212 対応 -->
    <!-- <div class="col-item">
      <b class="title">通夜の日付</b>
      <p>{{ kibiki?.tsuya_date }}</p>
    </div>
    <div class="col-item">
      <b class="title">告別式の日付</b>
      <p>{{ kibiki?.kokubetsushiki_date }}</p>
    </div>
    <div class="col-item">
      <b class="title">会場名</b>
      <p class="pre">{{ kibiki?.kaijou_name }}</p>
    </div>
    <div class="col-item">
      <b class="title">会場住所</b>
      <p class="pre">{{ kibiki?.kaijou_address }}</p>
    </div>
    <div class="col-item">
      <b class="title">会場TEL</b>
      <p>{{ kibiki?.kaijou_tel }}</p>
    </div> -->

    <div class="col-item">
      <b class="title">備考</b>
      <p class="pre">{{ form.notes ?? '無し' }}</p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import OptionConst from '@/const/Option';
import { Shinsei, KoyouKeiyakuTimeForDetail } from '@/types/Shinsei';
import { DateUtil } from "@/utils/DateUtil";
import dayjs from "dayjs";

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
    workTime: {
      type: Object as () => KoyouKeiyakuTimeForDetail[],
      default: null
    },
  },
  setup(props) {

    const kibiki = props.form.kibiki;

    const divStr = (val: number | null | undefined) => {
      if (!val) {
        return
      }
      return OptionConst.SHINSEI_DIV_OPTION.find(opt => opt.val === val)?.label
    }

    const timeFormat = (time: string | null | undefined) => {
      if (!time) {
        return
      }
      let splitTime = DateUtil.splitTimeString(time)
      return (Number(splitTime?.hour) + Number(splitTime?.minutes) / 60).toFixed(2)
    }

    const getWorkTime = (date: string | Date | null | undefined) => {
      if (!date) {
        return null
      }
      const d = dayjs(date)
      const id = props.form.shinsei_koyou_keiyaku_time?.find(function (v, k) {
        return d.isSame(v.target_date)
      })?.koyou_keiyaku_time_id
      const workTime = props.workTime.find(v => v.koyou_keiyaku_time_id == id) ?? null
      return workTime?.disp_work_time ?? '無し'
    }

    return {
      kibiki,
      'kyuukaDiv': OptionConst.SHINSEI_DIV_OPTION,
      divStr,
      timeFormat,
      getWorkTime,
    }
  },
  components: {

  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>
